import { Injectable } from '@angular/core';
import { InterruptionType } from '../domain/game-event';
import { collectsInterruptionType, isFloorball, Sport } from '../domain/sport';

@Injectable()
export class GameEventInterruptionTypeService {
  // game_start and game_end are considered legacy not used in the codebase
  readonly _allInterruptionTypes: { [key in InterruptionType]: string } = {
    period_start: 'Period start',
    period_end: 'Period end',
    icing: 'Icing',
    offside: 'Offside',
    puck_blocked_by_goalkeeper: 'Puck stopped by goalkeeper',
    puck_out: 'Puck out',
    goal: 'Goal',
    penalty: 'Penalty',
    timeout: 'Timeout',
    incorrect_pass_back: 'Incorrect pass back',
    high_stick: 'High stick',
    kicking_violation: 'Kicking',
    stick_hit: 'Stick hit',
    body_contact: 'Body contact',
    obstruction: 'Obstruction',
    foul: 'Other foul',
    official_touches_ball: 'Official touches ball',
    unnatural_interruption: 'Unnatural interruption',
    unspecified: 'Unspecified'
  };

  private readonly floorballLabels: Partial<Record<InterruptionType, string>> =
    {
      puck_out: 'Ball out'
    };

  readonly periodInterruptionTypes: Set<InterruptionType> = new Set([
    'period_start',
    'period_end'
  ]);

  getAllNonPeriodInterruptionTypes(): Set<InterruptionType> {
    return new Set(
      this.allInterruptionTypes.filter(
        (interruptionType) =>
          !this.periodInterruptionTypes.has(interruptionType)
      )
    );
  }

  get allInterruptionTypes(): InterruptionType[] {
    const result = Object.keys(this._allInterruptionTypes).filter((key) =>
      this._allInterruptionTypes.hasOwnProperty(key)
    ) as InterruptionType[];
    return result;
  }

  collectedInterruptionTypes(sport: Sport): InterruptionType[] {
    return this.allInterruptionTypes.filter((interruptionType) =>
      collectsInterruptionType(sport, interruptionType)
    );
  }

  getInterruptionTypeLabel(interruptionType: InterruptionType, sport?: Sport) {
    return (
      (isFloorball(sport) && this.floorballLabels[interruptionType]) ||
      this._allInterruptionTypes[interruptionType]
    );
  }
}
